module.exports = __webpack_public_path__ + "assets/img/amazon.3db49052.png";